import { getClosedModalState, getSavedInventoryState, globalAlerts } from '../utilities/inventorySearchDuckUtils';
export default (state, action, _ref) => {
  let {
    initialState,
    types
  } = _ref;
  switch (action.type) {
    case types.ADD_SAVED_INVENTORY_ITEM:
      {
        const updatedInventory = [...state.inventory];

        // Ensure deduped id from existing collection
        if (!updatedInventory.find(_ref2 => {
          let {
            listingId
          } = _ref2;
          return listingId === action.payload.listingId;
        })) {
          updatedInventory.push(action.payload);
        }
        return getSavedInventoryState(state, updatedInventory);
      }
    case types.REMOVE_SAVED_INVENTORY_ITEM:
      {
        const updatedInventory = state.inventory.filter(item => {
          if (typeof item === 'object') {
            return item.listingId !== action.payload;
          }
          return item !== action.payload;
        });
        const newState = getSavedInventoryState(state, updatedInventory);
        if (newState.inventory.length === 0) {
          newState.showQuickSaveList = false;
        }
        return newState;
      }
    case types.CLEAR_SAVED_INVENTORY:
      {
        return getSavedInventoryState(state, []);
      }
    case types.SET_SAVED_INVENTORY_ITEMS:
      {
        return getSavedInventoryState(state, action.payload);
      }
    case types.SET_SAVED_INVENTORY_ITEM_BY_INDEX:
      {
        const {
          index,
          id
        } = action.payload;
        const inventory = [...state.inventory];
        inventory.splice(index, 0, id);
        return getSavedInventoryState(state, inventory);
      }
    case types.SHOW_UPDATE_SAVED_INVENTORY:
      {
        return {
          ...state,
          ...getClosedModalState(state),
          ...initialState.updateSavedInventory,
          showUpdateSavedInventory: true,
          updateSavedInventory: action.payload
        };
      }
    case types.HIDE_UPDATE_SAVED_INVENTORY:
      {
        return {
          ...state,
          ...getClosedModalState(state)
        };
      }
    case types.SET_UPDATE_SAVED_INVENTORY_STATE:
      {
        return {
          ...state,
          updateSavedInventory: {
            ...state.updateSavedInventory,
            ...action.payload
          }
        };
      }
    case types.SHOW_QUICK_SAVE_NOTIFICATION:
      {
        return {
          ...state,
          ...getClosedModalState(state),
          showQuickSaveNotification: true
        };
      }
    case types.HIDE_QUICK_SAVE_NOTIFICATION:
      {
        return {
          ...state,
          ...getClosedModalState(state)
        };
      }
    case types.SET_MAX_QUICK_SAVES_LIMIT:
      {
        return {
          ...state,
          maxQuickSavesLimit: action.payload
        };
      }
    case types.SET_GLOBAL_ALERT:
      {
        const {
          key,
          message
        } = action.payload;
        const globalAlert = globalAlerts[key];
        if (message) {
          globalAlert.message = message;
        }
        return {
          ...state,
          globalAlert
        };
      }
    case types.CLEAR_GLOBAL_ALERT:
      {
        return {
          ...state,
          globalAlert: null
        };
      }
    case types.UPDATE_SAVED_INVENTORY:
      {
        const {
          id,
          version,
          ...rest
        } = action.payload;
        const updatedInventory = [...state.inventory];
        const index = updatedInventory.findIndex(_ref3 => {
          let {
            bookmarkId
          } = _ref3;
          return bookmarkId === id;
        });
        if (index > -1) {
          updatedInventory[index] = {
            ...updatedInventory[index],
            version,
            ...rest
          };
        }
        return getSavedInventoryState(state, updatedInventory);
      }
    case types.SET_ANIMATED_BUTTON_STATE:
      {
        return {
          ...state,
          animatedButtonState: action.payload
        };
      }
    default:
      return state;
  }
};